// extracted by mini-css-extract-plugin
export default {"table":"ExpertInternalNotesTable_table__xaqUQ","minutes":"ExpertInternalNotesTable_minutes__Xby1p","actions":"ExpertInternalNotesTable_actions__ZiE+N"};